import { Config } from "../config/Config";
import { firestore } from "../utilities/Firebase";

/**
 * スタンプサービス
 */
export const StampService = () => {
  /**
   * Firestore からスタンプデータを取得する
   * @param campaignId キャンペーンID
   * @param id スタンプID
   * @returns スタンプデータ
   */
  const getStamp = async (campaignId: string, id: string) => {
    const path = `${Config.appEnv}/${campaignId}/Stamps`;
    const doc = await firestore.collection(path).doc(id).get();
    const data = doc.data();

    if (!data) {
      throw new Error(`Stamp is not found. id: ${id}`);
    }

    return { id: doc.id, data };
  };

  /**
   * Firestore から対象カテゴリのスタンプ一覧を取得する
   * @param campaignId キャンペーンID
   * @param category カテゴリ
   * @returns カテゴリに属するスタンプのリスト
   */
  const getStampList = async (campaignId: string, category: string) => {
    const path = `${Config.appEnv}/${campaignId}/Stamps`;
    const ref = firestore.collection(path);
    const snapshot = await ref.where("category", "==", category).get();
    const stampList = snapshot.docs.map(doc => {
      return { id: doc.id, data: doc.data() }
    }).filter(stamp => !stamp.data["isClosed"]);
    return stampList;
  };

  return { getStamp, getStampList };
};
